
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gw9TPewPwDD2fnAw8x5VO0Ol6X95x6LPbTJwPB5xvf2kMeta } from "/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexvWG_451vO_ZPh9OrZR1p9ByMvOyksq6VtewarLdAy4q6EMeta } from "/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchj53Dqiu4PC0ZWzrWmmf3dfqrwSpQHEL7WAiHe5VhxPMMeta } from "/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indextEK6gfMbqpwv5UVn4e2nVF_45E0bY22girB2dWVr_K68MMeta } from "/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93rszcZkrnI13PJ3arTEvjjzysA0EIeuudsan_45dr07fl4Meta } from "/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexQNUZmr7EUYvSgqAZhBw9EKVwrWXgJofK4Us05PvAixEMeta } from "/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93S6U5dptMI3fwNizwuTeoJc7C_CWo9Luyr4gmUsLCkroMeta } from "/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexcjsbNrBskXJpvvjM4iYzk8LI6o3dlwgy2KkAXmFvU5AMeta } from "/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93pbfLfTinsgUfuzsFzA9qL4yTrhCtw1soaa_1GnDbyV8Meta } from "/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexRgIipKOP0uPMbPQcW8oZmNS_45hwDuhnoqCusHz5Hh0mAMeta } from "/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexyB_krgMb0gV26qJOSgdVGL3zdmi17ghsro6xoAeqS4kMeta } from "/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexQNUZmr7EUYvSgqAZhBw9EKVwrWXgJofK4Us05PvAixEMeta || {},
    component: () => import("/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexcjsbNrBskXJpvvjM4iYzk8LI6o3dlwgy2KkAXmFvU5AMeta || {},
    component: () => import("/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexRgIipKOP0uPMbPQcW8oZmNS_45hwDuhnoqCusHz5Hh0mAMeta || {},
    component: () => import("/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexyB_krgMb0gV26qJOSgdVGL3zdmi17ghsro6xoAeqS4kMeta || {},
    component: () => import("/codebuild/output/src585062668/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]